import React, { useState, useEffect } from "react";
import { useTransition, animated } from "react-spring";

const ThankYou = () => {
  const [isVisible, setIsVisible] = useState(true);

  // Same transition effect as the PropertyUse component
  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(500px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="max-w-7xl mx-auto px-8 flex flex-col justify-center items-center min-h-[90vh] md:h-full">
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className="mx-auto flex flex-col justify-center items-center md:pt-8">
              <h1 className="text-5xl text-blue-primary font-bold text-center mb-4 md:mb-6">THANK YOU!</h1>
              <p className="text-2xl text-blue-primary text-center">
                We've received your request and someone will be in touch shortly.
              </p>
            </animated.div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default ThankYou;
